import styled from "styled-components";
import { colors } from "@/theme";

export const CartItemsToShipTable = styled.div`
  display: grid;
  grid-template-columns: auto;
  row-gap: 12px;
`;

export const CartItemsToShipTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.2fr 0.3fr;
  align-items: center;
  justify-items: center;
`;

export const CartItemsToShipTableProduct = styled.div``;

export const CartItemsToShipTableOrderQuantity = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;

export const CartItemsToShipTableShippingQuantity = styled.div`
  color: ${colors.black};
  text-align: center;
  font-family: "PF DIN Text Pro";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
